<script>
export default {
  name: 'NewRoom',
  setup() {
    const commoditiesList = [
      {
        label: 'Wifi',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Un wifi haut débit pour rester connecté.',
      },
      {
        label: 'Double chambre',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Deux chambres bien équipés.',
      },
      {
        label: 'Cuisine Moderne équipé',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Une Cuisine avec toutes les commodités.',
      },
      {
        label: 'Cuisine Moderne équipé',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Une Cuisine avec toutes les commodités.',
      },
      {
        label: 'Chauffe eau',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Une Douche équipé d\'un de système de chauffe eau .',
      },
      {
        label: 'Tv',
        icon: 'fa fa-tv fa-2x',
        desc: 'Un écran Tv Plasma avec abonnement canal +.',
      },
      {
        label: 'Climatisation',
        icon: 'fa fa-fan fa-2x',
        desc: 'Une climatisation fonctionnel.',
      },
      {
        label: '2 Tv',
        icon: 'fa fa-tv fa-2x',
        desc: 'Deux écrans Tv Plasma pour chaque pièce avec abonnement canal +.',
      },
      {
        label: 'Deux douche',
        icon: 'fa-bathtub fa-2x',
        desc: 'Deux douches de haut standing pour chaque chambre avec toutes les commodités.',
      },
      {
        label: 'Une douche',
        icon: 'fa-bathtub fa-2x',
        desc: 'Une douches de haut standing avec toutes les commodités.',
      },
      {
        label: 'Salle de gym',
        icon: 'fa-heart fa-2x',
        desc: 'Un accès gratuit à une salle de gymnase bien équipée.',
      },
      {
        label: 'Petit-déjeuner',
        icon: 'fa fa-coffee fa-2x',
        desc: 'Un petit déjeuner offer.',
      },
      {
        label: 'Salle de jeu',
        icon: 'fa fa-child fa-2x',
        desc: 'Un espace pour les tout petit.',
      },
    ]

    return {
      commoditiesList,
    }
  },
  data() {
    return {
      roomStatus: [
        {
          label: 'En service',
          code: 30,
        },
        {
          label: 'Hors service',
          code: 0,
        },
        {
          label: 'Occupé',
          code: 405,
        },
      ],
      room: {
        room_name: '',
        room_description: '',
        room_spec: [],
        room_create_date: '',
        room_status: 400,
        room_unit_price: 0,
        room_total_price: 0,
        room_photos: [],
        room_state: '',
        apartment_id: 0,
        room_type_id: 0,
      },
      roomtypes_list: [
        {id: 1, name: 'studios 2 piece'},
        {id: 2, name: 'studios 3 piece'},
        {id: 3, name: 'salle de reunion'},
      ],
      apartments_list: [
        {id: 1, name: 'Batiment A'},
        {id: 2, name: 'Batiment E'},
      ],
    }
  },
  mounted() {
    this.loadRoomType()
    this.loadApartments()
  },
  methods: {
    loadRoomType() {
      this.$axios.get(this.$endpoint.LoadRoomType).then(rp => {
        this.roomtypes_list = rp.data
        console.log(rp)
      })
    },
    newRoom(e) {
      this.$axios.post(this.$endpoint.CreateRoom, new FormData(e), {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        this.room = {
          room_name: '',
          room_description: '',
          room_spec: [],
          room_create_date: '',
          room_status: 400,
          room_unit_price: 0,
          room_total_price: 0,
          room_photos: [],
          room_state: '',
          apartment_id: 0,
          room_type_id: 0,
        }
      })
    },
    loadApartments() {
      this.$axios.get(this.$endpoint.LoadApartment).then(rp => {
        this.apartments_list = rp.data
      })
    },
  },
}
</script>

<template>
  <div>
    <v-row>
      <v-col
          cols="12"
          md="12"
      >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Nouvelle chambre
            </span>
      </v-col>
    </v-row>
    <v-form
        class="multi-col-validation"
        style="margin-top:1rem; margin-left: 1rem; margin-bottom: 1.5rem;"
        @submit.prevent="newRoom($event.target)"
    >
      <v-row>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="room.room_name"
              dense
              hide-details
              name="room_name"
              label="Numéro de la chambre"
              outlined
              required
              placeholder="Numéro"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="room.room_create_date"
              dense
              required
              type="date"
              name="room_create_date"
              hide-details
              label="Date de création"
              outlined
              placeholder="Création"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="room.room_unit_price"
              dense
              required
              name="room_unit_price"
              hide-details
              label="Prix unitaire"
              outlined
              placeholder="prix"
          ></v-text-field>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="room.room_total_price"
              dense
              name="room_total_price"
              required
              hide-details
              label="Prix de vente"
              outlined
              placeholder="prix de vente"
          ></v-text-field>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-select
              v-model="room.room_type_id"
              dense
              required
              name="room_type_id"
              :item-text="'room_type_name'"
              :item-value="'id'"
              :items="roomtypes_list"
              label="Type de chambre"
              outlined
          ></v-select>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <!--                :value="apartments_list.id"-->
          <v-select
              v-model="room.apartment_id"
              dense
              required
              :items="apartments_list"
              name="apartment_id"
              :item-text="'apart_bloc'"
              :item-value="'id'"
              label="Block d'appartement concerné"
              outlined
          ></v-select>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-file-input
              v-model="room.room_photos"
              dense
              required
              name="room_photos[]"
              type="file"
              multiple
              hide-details
              label="Images de la chambre"
              outlined
              placeholder="Selectionner les photos de la chambres"
          ></v-file-input>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-select
              v-model="room.room_state"
              :item-text="'label'"
              :item-value="'code'"
              :items="roomStatus"
              dense
              label="État"
              name="room_state"
              outlined
              required
          ></v-select>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-textarea
              v-model="room.room_description"
              dense
              required
              name="room_description"
              label="Description de la l'appart"
              outlined
          ></v-textarea>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-select
              v-model="room.room_spec"
              :items="commoditiesList"
              :item-text="'label'"
              multiple
              dense
              label="Commodités"
              outlined
              chips
              name="room_spec">
          </v-select>
        </v-col>
        <v-col cols="12">
          <v-btn color="primary" type="submit">
            Creer
          </v-btn>
          <v-btn
              class="mx-2"
              outlined
              type="reset"
          >
            Annuler
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>

</style>